import { v4 as uuidv4 } from 'uuid'

import { type SanityFrameBuilderStrings } from '../data/sanity/queries/types/strings'

/**
 * Determines if JavaScript object is numeric.
 */
export const isNumeric = (object: any) => {
  const normalizedObject =
    typeof object === 'string' ? object.replace(/,/g, '') : object

  return (
    !isNaN(parseFloat(normalizedObject)) &&
    isFinite(normalizedObject) &&
    Object.prototype.toString.call(normalizedObject).toLowerCase() !==
      '[object array]'
  )
}

export const clamp = (value: number, min: number, max: number) => {
  return min > value ? min : max < value ? max : value
}

/**
 * Converts an array of objects into a single record maintaining all key and value pairs.
 */
export const toRecord = <T>(objects: { [x: string]: T }[]): Record<string, T> =>
  Object.assign({}, ...objects)

/**
 * Gets item title text.
 */
export function getItemTitle(
  frameBuilderStrings: SanityFrameBuilderStrings,
  title: string,
  discountPercent?: number | null,
) {
  if (!discountPercent) {
    return title
  }

  return [
    title,
    `${frameBuilderStrings.discountPercentLabel}`.replace(
      '{value}',
      `${discountPercent}`,
    ),
  ].join(' - ')
}

export const stringToHash = (string: string) => {
  let hash = 0
  let chr: number

  if (string.length === 0) {
    return hash
  }

  for (let i = 0; i < string.length; i += 1) {
    chr = string.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0
  }

  return hash
}

/**
 * Generates a random string based on UUID.
 */
export const getRandomString = () => Buffer.from(uuidv4()).toString('base64')
